// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"SwatchOption-visuallyHidden-NWm"};